export default "__VITE_PUBLIC_ASSET__0a3e5073__"